import * as Cookie from '../common/cookie';

export  const MakeCustomDimension = () => {
    counterNota();
    //let date = new Date();
    //let mesActual = (`0${date.getMonth() + 1}`).slice(-2);
    //let mesNotasLeidas = localStorage.getItem("mesNotasLeidas");
    //if (mesNotasLeidas !== null) {
    //    if (mesActual === mesNotasLeidas) {
    //        addNotaRead();
    //    } else {
    //        localStorage.removeItem("mesNotasLeidas");
    //        localStorage.removeItem("CDnotasLeidas");
    //        localStorage.setItem("mesNotasLeidas", mesActual);
    //        addNotaRead();
    //    }
    //} else {
    //    localStorage.setItem("mesNotasLeidas", mesActual);
    //    addNotaRead();
    //}

}

const counterNota = () => {
        const divNota = document.querySelector("div[data-notaid]");
        let notaId;
        let lsNotasCounter = JSON.parse(localStorage.getItem("NotasCounterData"));
        let lsDayCheckCounter = localStorage.getItem("DayCheckCounter");
        let today = new Date();

        let fechaHoy = today.getFullYear() + "-" + (today.getMonth() + 1)  + "-" + today.getDate();

        // Una vez por dia para ser mas performante
        // Se encarga de filtrar las notas que superan los X dias ( 28 seteado hoy )
        if (lsDayCheckCounter != null && lsNotasCounter != null && lsDayCheckCounter != today.getDate()) {
            lsNotasCounter = lsNotasCounter.filter(n => checkDateCounter(n.fecha));
            localStorage.setItem("NotasCounterData", JSON.stringify(lsNotasCounter));
            localStorage.setItem("DayCheckCounter", today.getDate());
        } else if(lsDayCheckCounter == null){
            localStorage.setItem("DayCheckCounter", today.getDate());
        }


        if (divNota != null) {
            notaId = divNota.getAttribute("data-notaid");

            if (lsNotasCounter != null) {
                let objTemp = lsNotasCounter;
                if (!objTemp.some(n => n.notaId === notaId)) {
                    objTemp.push({ "notaId": notaId, "fecha": fechaHoy });
                    localStorage.setItem("NotasCounterData", JSON.stringify(objTemp));
                    localStorage.setItem("countNotas", objTemp.length);
                    Cookie.CreateCookie("countNotas", objTemp.length);
                }
            } else {
                let objNotas = [{ "notaId": notaId, "fecha": fechaHoy }];
                localStorage.setItem("NotasCounterData", JSON.stringify(objNotas) );
                localStorage.setItem("countNotas", objNotas.length);
                Cookie.CreateCookie("countNotas", objNotas.length);
            }
        }

    }

    const checkDateCounter = (fechaCheck) => {
        let date1 = new Date(fechaCheck);
        let date2 = new Date(Date.now());
        var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24));

        if (diffDays < 28) {
            return true;
        } else {
            return false;
        }

    }

const addNotaRead = () => {
    let lSnotasLeidas = localStorage.getItem("CDnotasLeidas");

    lSnotasLeidas = lSnotasLeidas ? lSnotasLeidas : 0;

    lSnotasLeidas = parseInt(lSnotasLeidas) + 1;
    localStorage.setItem("CDnotasLeidas" ,lSnotasLeidas);

}





// WEBPACK FOOTER //
// ./Statics/scripts/nota/NotaCustomDimension.js